import type { AccommodationInventoryModel, ExperienceInventoryModel, HospitalityTicketInventoryModel, TravelExperienceInventoryModel } from '@/types/BookingGameMetadataModel';
import BigNumber from 'bignumber.js';

export function formatCurrency(value: number | string | BigNumber) {
	const n = value instanceof BigNumber ? value : new BigNumber(value);
	return 'NZ$' + (n.isInteger() ? n.toFormat(0) : n.toFormat(2));
}

export function formatHospitalityTicketInventory(item: HospitalityTicketInventoryModel) {
	return `${item.DisplayName} (${formatCurrency(item.UnitRrpExclGst)} ${item.PricingType})${item.IsSoldOut ? ' - SOLD OUT' : ''}`;
}

export function formatAccommodation(item: AccommodationInventoryModel) {
	return `${item.DisplayName}: ${item.FormattedDateRange} (${formatCurrency(item.UnitRrpExclGst)} ${item.PricingType})${item.IsSoldOut ? ' - SOLD OUT' : ''}`;
}

export function formatExperience(item: ExperienceInventoryModel) {
	return `${item.DisplayName}${item.IsSoldOut ? ' - SOLD OUT' : ''}`;
}

export function formatTravelExperience(item: TravelExperienceInventoryModel) {
	return `${item.DisplayName}${item.IsSoldOut ? ' - SOLD OUT' : ''}`;
}
